module.exports = __webpack_public_path__ + "static/media/wind.ccba539.mp3";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/active/snail/fifth/mp3/wind.mp3
// module id = kfkj
// module chunks = 1 3